import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { userCardStore } from 'shared/store/userCard'
import { toaster } from 'uikit/Toaster'

export const useUpdateUserInternal = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: any) => {
      const { id, ...data } = payload
      return api.users.updateUserInternal(id, data)
    },
    onSuccess: (data) => {
      userCardStore.setState((state) => ({
        ...state,
        ...data,
      }))

      queryClient.invalidateQueries({ queryKey: ['passportJournal'] })

      toaster.create({
        type: 'success',
        title: 'Данные успешно обновлены',
      })
    },
    onError: (err: any) => {
      const data = err.response.data
      const message = data.message || err.message

      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при обновлении данных пользователя',
        description: message,
      })
    },
  })
}
